import { apiAxios } from '@/helpers'
import i18n from '@/i18n/i18n'
/* import vuetifyToast from 'vuetify-toast'
const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'success',
    timeout: 2000,
    icon: 'check',
  })
} */
const initialState = () => {
  return {
    module: 'stats',
    loading: false,
    totalStats: {},
    topLocations: [],
    populars: {},
    topVoting: [],
    list: [],
    pendingUsers: {
      items: [],
      filters: {},
      pagination: {
        hasMore: false,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
      },
    },
  }
}

const state = initialState()

const getters = {
  topLocations(state) {
    return state.topLocations.map((item) => {
      return {
        [i18n.t('titles.matches.total')]: item.province,
        value: item.count,
      }
    })
  },
  populars(state) {
    let result = {}
    Object.keys(state.populars).forEach((key) => {
      result[key] = state.populars[key].map((item) => ({
        name: item.name,
        [i18n.t('titles.global.followers')]: item.count,
      }))
    })
    return result
  },
}

const actions = {
  async fetchStats({ dispatch, commit }, vm) {
    commit('setLoading', true)
    let promises = [
      dispatch('fetchTotalStats'),
      dispatch('fetchPendingUsers'),
      dispatch('fetchPopulars'),
    ]
    if (vm.isAdmin) promises.push(dispatch('fetchTopLocations'))
    await Promise.all(promises).finally(() => commit('setLoading', false))
  },
  async fetchTotalStats({ commit, state }) {
    const { data } = await apiAxios.post(state.module + '/total_stats')
    commit('setTotalStats', data.data.stats || {})
  },
  async fetchPendingUsers({ commit, state }) {
    let query = {
      page: state.pendingUsers.pagination.page,
      limit: state.pendingUsers.pagination.rowsPerPage,
    }
    const { data } = await apiAxios.post(
      state.module + '/pending_users',
      state.pendingUsers.filters,
      { params: { ...query } }
    )
    commit('setPendingUsers', data.data.stats || [])
    commit('setPendingUsersPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })
  },
  async fetchTopLocations({ commit, state }) {
    const { data } = await apiAxios.post(state.module + '/top_locations')
    commit('setTopLocations', data.data.stats || [])
  },
  async fetchPopulars({ commit, state }) {
    const { data } = await apiAxios.post(state.module + '/populars')
    commit('setPopulars', data.data.stats || {})
  },
  async fetchTopVoting({ commit, state }, { params, query }) {
    const { data } = await apiAxios.post(state.module + '/top_voting', params, {
      params: query,
    })
    let stats = data.data && data.data.stats ? data.data.stats : []
    commit('setTopVoting', stats)
    return data
  },
}

const mutations = {
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  setTotalStats(state, payload) {
    state.totalStats = {}
    state.totalStats = payload
  },
  setPendingUsers(state, payload) {
    state.pendingUsers.items = []
    payload.forEach((item) => state.pendingUsers.items.push(item))
  },
  setPendingUsersFilters(state, payload) {
    console.log('setPendingUsersFilters', payload)
    state.pendingUsers.filters = state.pendingUsers.filters = {
      ...state.pendingUsers.filters,
      ...payload,
    }
  },
  setPendingUsersPagination(state, payload) {
    state.pendingUsers.pagination = {
      ...state.pendingUsers.pagination,
      ...payload,
    }
  },
  setTopLocations(state, payload) {
    state.topLocations = []
    payload.forEach((item) => state.topLocations.push(item))
  },
  setPopulars(state, payload) {
    state.populars = {}
    state.populars = payload
  },
  setTopVoting(state, payload) {
    state.topVoting = []
    payload.forEach((item) => state.topVoting.push(item))
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
